import * as React from 'react';
import { ReactComponent as TrashIconSVG } from '../../assets/icons/mevo/ic_trash.svg';
import IconPattern, { IconProps } from './_IconPattern';

const TrashIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={TrashIconSVG} variantPlaces={1} {...props} />;
};

export default TrashIcon;
